import { HelpCenterSheet } from "./HelpCenterSheet";
import { SubmitTicketDialog } from "./SubmitTicketDialog";

/**
 * Mounts every global support UI element (Help Center sheet, Submit Ticket
 * dialog) once at the app root. Listens to SupportContext for open state.
 */
export function SupportRoot() {
  return (
    <>
      <HelpCenterSheet />
      <SubmitTicketDialog />
    </>
  );
}
